import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function CommitmentsSection() {
  const commitments = ['Regular Eedi use across all participating maths classes and year groups for the full academic year (min. two teachers).', "Regularly use Eedi's full features: diagnostics, interventions, and automated retrieval practice.", 'Administer STAR assessments (baseline, midline, endline) to track student progress.', 'Students complete a minimum of 24 quizzes per year to qualify for the £500 Base Award.', 'Designate a lead teacher/coordinator for Eedi implementation and research coordination.', 'Participate in 2-3 R&D pilots annually to test new features and gather learning effectiveness data.', 'Sync MIS data via Wonde or Clever for seamless integration and accurate progress tracking.'];
  return <section className="py-20 bg-gray-50" data-id="element-139">
      <div className="container mx-auto px-4" data-id="element-140">
        <div className="max-w-4xl mx-auto" data-id="element-141">
          <div className="inline-flex items-center px-3 py-1.5 bg-blue-100 rounded-full mb-4" data-id="element-142">
            <span className="text-blue-700 font-medium" data-id="element-143">
              Participation Requirements
            </span>
          </div>
          <h2 className="text-3xl font-bold mb-4" data-id="element-144">
            🤝 What We Ask from You: Commitments
          </h2>
          <div className="w-16 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mb-6" data-id="element-145"></div>
          <p className="text-lg text-gray-700 mb-10 max-w-3xl" data-id="element-146">
            To make the most of this exciting initiative and ensure meaningful
            research outcomes, we ask participating schools to commit to the
            following:
          </p>
          <div className="bg-white rounded-xl shadow-md p-8 border border-gray-100" data-id="element-147">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-148">
              {commitments.map((commitment, index) => <div key={index} className="flex items-start group" data-id="element-149">
                  <CheckCircleIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5 group-hover:text-green-600 transition-colors" data-id="element-150" />
                  <p className="text-gray-700" data-id="element-151">{commitment}</p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}